import type { LegalContent } from "./types";

export const privacyEn: LegalContent = {
  seo: {
    title: "Privacy Policy - Luxoria",
    description: "How Luxoria handles photos, videos, permissions, temporary files, and data."
  },
  tag: "Legal",
  title: "Privacy Policy",
  lastUpdated: "Last updated: June 8, 2026",
  sections: [
    {
      heading: "1. Overview",
      body: "This Privacy Policy explains how Luxoria handles your photos, videos, and related information when you use the app to convert SDR media into HDR-ready outputs. Luxoria runs its conversions on your device."
    },
    {
      heading: "2. Photos and Videos",
      body: "Luxoria processes the photos and videos you explicitly select for HDR conversion. Your media is used to produce converted output files and is not used for any unrelated purpose."
    },
    {
      heading: "3. Local Processing",
      body: "HDR conversion is performed as part of the app's local processing workflow on your device. Luxoria is built to keep the conversion flow on-device rather than relying on an external processing service, and your photos and videos are not uploaded to our servers."
    },
    {
      heading: "4. Temporary Files",
      body: "During conversion and export, Luxoria may create temporary output files to support saving and sharing. These temporary files are scoped to the operation and may be cleaned up by the app after use."
    },
    {
      heading: "5. Permissions",
      body: "Depending on your platform and chosen workflow, Luxoria may request access to your Photos library or to files you select. These permissions are used to read the media you choose and to save converted results."
    },
    {
      heading: "6. Data Collection",
      body: "Luxoria does not require an account to convert media. The app focuses on processing the media you select rather than collecting personal profiles. Any diagnostic information you choose to send by email is handled only to provide support."
    },
    {
      heading: "7. Third-Party Services",
      body: "Core HDR conversion does not depend on third-party content services. System features such as Photos, Files, or the platform share sheet are governed by your operating system and its own terms."
    },
    {
      heading: "8. Children's Privacy",
      body: "Luxoria is a general-purpose media conversion tool and is not directed to children. We do not knowingly request personal information from children."
    },
    {
      heading: "9. Changes to This Policy",
      body: "We may update this Privacy Policy as the app evolves. When we make material changes, we will update the date shown above. Continued use of Luxoria indicates acceptance of the updated policy."
    },
    {
      heading: "10. Contact Us",
      body: "If you have questions about this Privacy Policy or how Luxoria handles your media, contact us at axqora@gmail.com."
    }
  ],
  contact: {
    title: "Questions about privacy?",
    body: "Email us at axqora@gmail.com and we will get back to you."
  }
};
